import { container } from '../../../DataDomain';
import { IUnsubscribeEntity, IUnsubscribeReqBody } from '../../../entity/interface/iUnsubscribe';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IUnsubscribeUseCase {
    execute(username: string, token: string, reqBody: IUnsubscribeReqBody): Promise<IUnsubscribeEntity>;
}
export class UnsubscribeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(username: string, token: string, reqBody: IUnsubscribeReqBody): Promise<IUnsubscribeEntity> {
        return await this.subscriptionRepository.unsubscribe(username, token, reqBody);
    }
}
